module.exports = __webpack_public_path__ + "static/media/SL 14.99765d2b.mp3";